import { render, staticRenderFns } from "./FormBasicDialogWrap.vue?vue&type=template&id=44bd0728&scoped=true&"
import script from "./FormBasicDialogWrap.vue?vue&type=script&lang=ts&"
export * from "./FormBasicDialogWrap.vue?vue&type=script&lang=ts&"
import style0 from "./FormBasicDialogWrap.vue?vue&type=style&index=0&id=44bd0728&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44bd0728",
  null
  
)

export default component.exports